import ee from 'event-emitter'

import { NOTIFICATIONS } from '../core/constants'
import getPushNotificationClass from '../core/push-notifications'
import chalet from './chalet'

const notificationService = ee()

export const subscribeToNotifications = ({
  onCalendarSyncSuccess,
  onCalendarSyncDenied,
  onPushNotification
}) => {
  notificationService.on(NOTIFICATIONS.CALENDAR_SYNC_OK, onCalendarSyncSuccess)
  notificationService.on(NOTIFICATIONS.CALENDAR_SYNC_DENIED, onCalendarSyncDenied)
  const PushNotificationClient = getPushNotificationClass()

  if (PushNotificationClient) {
    const client = new PushNotificationClient(onPushNotification)

    chalet.connection.registerServiceClient('MEETINGS', client)
  }
}

export default notificationService
